import React, { useState } from 'react';
import { Box, Button, Card, CardContent, TextField, Typography, Avatar, Stack } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '@vmcom/ui';

const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const { login } = useAuth() as {
    login: (username: string, password: string) => Promise<{ success: boolean; error?: string }>;
  };
  const { toast } = useToast();

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!username.trim() || !password) {
      toast('Введите логин и пароль', 'warning');
      return;
    }
    setLoading(true);
    const result = await login(username.trim(), password);
    setLoading(false);
    if (result.success) toast('Добро пожаловать', 'success');
    else toast(result.error || 'Ошибка авторизации', 'error');
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'grey.100',
        p: 2,
      }}
    >
      <Card sx={{ width: '100%', maxWidth: 400 }} elevation={2}>
        <CardContent sx={{ p: 3 }}>
          <Stack alignItems="center" spacing={1} sx={{ mb: 3 }}>
            <Avatar sx={{ bgcolor: 'primary.main', width: 48, height: 48, fontWeight: 700 }}>GP</Avatar>
            <Typography variant="h5" fontWeight={700}>
              VMCOM AIO
            </Typography>
            <Typography variant="body2" color="text.secondary" textAlign="center">
              AI content management platform
            </Typography>
          </Stack>
          <Box component="form" onSubmit={onSubmit}>
            <TextField
              fullWidth
              label="Имя пользователя"
              margin="normal"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
            />
            <TextField
              fullWidth
              label="Пароль"
              type="password"
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
            <Button fullWidth type="submit" variant="contained" size="large" sx={{ mt: 2 }} disabled={loading}>
              {loading ? 'Вход…' : 'Войти'}
            </Button>
          </Box>
        </CardContent>
      </Card>
      <Typography variant="caption" color="text.secondary" sx={{ position: 'fixed', bottom: 16 }}>
        © VMCOM 2019–{new Date().getFullYear()}
      </Typography>
    </Box>
  );
};

export default Login;
